/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleretouch2Inputs */

const en_refineexampleretouch2 = /** @type {(inputs: Refineexampleretouch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retouch`)
};

const de_refineexampleretouch2 = /** @type {(inputs: Refineexampleretouch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retuschieren`)
};

/**
* | output |
* | --- |
* | "Retouch" |
*
* @param {Refineexampleretouch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleretouch2 = /** @type {((inputs?: Refineexampleretouch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleretouch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleretouch2(inputs)
	return de_refineexampleretouch2(inputs)
});
export { refineexampleretouch2 as "refineExampleRetouch" }